import { QuestionnaireReference } from '@/training/domains';
import { localDateTimeFromString } from '@/utils/DateUtils';

export const questionnaires: Array<QuestionnaireReference> = [
  {
    id: 'qid',
    groupId: 'group00',
    title: 'アンケートのタイトル',
    userIds: ['uid', 'uid1'],
    text: 'text',
    createdAt: localDateTimeFromString('2021-01-01T10:00:00.000Z'),
    createdBy: 'user00',
    options: ['option1', 'option2'],
    respondent: [],
    status: 'active',
    finishedAt: undefined,
  },
  {
    id: 'qid1',
    groupId: 'group00',
    title: 'title',
    userIds: ['uid', 'uid1'],
    text: 'text',
    createdAt: localDateTimeFromString('2021-01-01T10:00:00.000Z'),
    createdBy: 'user00',
    options: ['option1', 'option2'],
    respondent: [],
    status: 'finished',
    finishedAt: localDateTimeFromString('2021-02-01T10:00:00.000Z'),
  },
];
